import React from 'react'

import { UrgencyTextGreen } from '../featureVariables'
import { StickyFooterContentTitle } from './StickyFooterContentTitle'

import classes from './StickyFooterContent.module.scss'
import { GlobalCtaStickyFooterExperiment } from '../../experiments/pen-5032_v1_global_ctas_sticky_footer'

interface StickyFooterContentProps {
  SignUpCta: React.ComponentType
  PricingText: React.ComponentType
}

export const StickyFooterContent = ({
  SignUpCta,
  PricingText,
}: StickyFooterContentProps) => (
  <GlobalCtaStickyFooterExperiment
    Control={() => <Content SignUpCta={SignUpCta} PricingText={PricingText} />}
    SignUpCta={SignUpCta}
    PricingText={PricingText}
  />
)

const Content = ({ SignUpCta, PricingText }: StickyFooterContentProps) => (
  <div className='container mc-p-4'>
    {/* Desktop view */}
    <div className='d-none d-sm-flex align-items-center justify-content-between'>
      <div className='d-flex flex-wrap align-items-center'>
        <StickyFooterContentTitle />
        <p className='mc-text-small'>
          <UrgencyTextGreen />
        </p>
      </div>
      <div className='d-flex align-items-center mc-ml-2'>
        <p className='mc-text-h7 mc-mr-2 mc-mr-md-4'>
          <PricingText />
        </p>
        <SignUpCta />
      </div>
    </div>

    {/* Mobile view */}
    <div className='d-flex d-sm-none flex-column mc-gap-3'>
      <div className='d-flex align-items-center justify-content-between mc-gap-4'>
        <StickyFooterContentTitle />
        <SignUpCta />
      </div>
      <div
        className={`d-flex justify-content-between mc-gap-4 ${classes.bottomContainer}`}
      >
        <p
          className='mc-font-caption align-self-end'
          style={{ minWidth: '33%' }}
        >
          <UrgencyTextGreen />
        </p>
        <p className='mc-font-caption mc-text--right'>
          <PricingText />
        </p>
      </div>
    </div>
  </div>
)
